/* Single source of truth for which NATIVE (in-house) casino games exist.

   Pure data — NO component or asset imports — so it is cheap and safe to unit-test and to
   import anywhere without pulling the whole Casino page. pages/Casino.jsx builds both the
   desktop host AND (via the shared buildCasinoGames) the mobile host from these ids, and
   asserts in dev that the host map hosts exactly NATIVE_GAME_IDS.

   WHY THIS EXISTS (R-036): every native Original except Mines, plus the native live tables,
   silently failed to open on mobile because the mobile launcher and the desktop host had
   diverged. Now there is ONE id list + ONE host factory, and a CI test + dev assertions keep
   them in lockstep. ADDING A NEW NATIVE GAME: add its id here, then either its component
   in buildCasinoGames or its dedicated page in ORIGINAL_PAGE_ROUTES and App routes. */

// Dedicated Originals use the same full page on both platforms. All other native games
// use the shared host factory; this catalog is the single routing contract for both.
export const ORIGINAL_PAGE_ROUTES = Object.freeze(Object.assign(Object.create(null), { "dragon-tower": "/casino/dragon-tower", keno: "/casino/keno", plinko: "/casino/plinko", mines: "/casino/mines", dice: "/casino/dice", crash: "/casino/crash", coinflip: "/casino/coinflip", roulette: "/casino/roulette", blackjack: "/casino/blackjack", baccarat: "/casino/baccarat", slots: "/casino/slots", hilo: "/casino/hilo" }));
export const nativeGamePath = id => ORIGINAL_PAGE_ROUTES[id] || `/casino/play/${encodeURIComponent(id)}`;

export const ORIGINAL_IDS = ["dragon-tower", "keno", "plinko", "mines", "dice", "crash", "blackjack", "slots", "roulette", "coinflip", "baccarat", "hilo"];

// Native live-dealer tables (their own in-house components, not provider games).
export const LIVE_TABLE_IDS = ["liveblackjack", "live"];

// Every slug the shared native game host (buildCasinoGames) must handle — i.e. originals without a dedicated
// page, plus native live tables. Legacy /casino/play/:slug links redirect dedicated games.
export const NATIVE_GAME_IDS = [
  ...ORIGINAL_IDS.filter((id) => !ORIGINAL_PAGE_ROUTES[id]),
  ...LIVE_TABLE_IDS,
];
